import { render, staticRenderFns } from "./ModalDocs.vue?vue&type=template&id=13023f03"
import script from "./ModalDocs.vue?vue&type=script&lang=js"
export * from "./ModalDocs.vue?vue&type=script&lang=js"
import style0 from "./ModalDocs.vue?vue&type=style&index=0&id=13023f03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports